/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import EmployeeUserManagementContainer from './employee/container/EmployeeUserManagementContainer';
import BarangayUserManagementContainer from './barangays/container/BarangayUsersManagementContainer';

function UserManagementContainer({ match }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">User Management</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/user-management/employees"
        >
          City Hall
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/user-management/barangays"
        >
          Barangay Admin
        </NavLink>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/employees`} />}
        />

        <Route
          path={`${match.path}/employees`}
          component={EmployeeUserManagementContainer}
        />
        <Route
          path={`${match.path}/barangays`}
          component={BarangayUserManagementContainer}
        />
      </Switch>
    </div>
  );
}

UserManagementContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(UserManagementContainer);
